import Button from "@/v2-backoffice-client/components/button"
import { useDateRangePickerContext } from "./dateRangePicker.context"

function DateRangePickerFooter() {
  const { mode, value, start, end, apply, clear, cancel } =
    useDateRangePickerContext()

  const canApply =
    (mode === "within" && !!start && !!end) ||
    (mode === "before" && !!end) ||
    (mode === "after" && !!start)

  const hasSelection = !!start || !!end || !!value

  return (
    <div className="ui-date-picker-footer">
      <Button
        variant="ghost"
        size="tiny"
        disabled={!hasSelection}
        onClick={clear}
      >
        Clear
      </Button>
      <div className="ui-date-picker-spacer" />
      <Button variant="ghost" size="tiny" onClick={cancel}>
        Cancel
      </Button>
      <Button size="tiny" disabled={!canApply} onClick={apply}>
        Apply
      </Button>
    </div>
  )
}

export default DateRangePickerFooter
